// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b6905749","835":"17ad36b5"}[chunkId] + ".chunk.js";
};